import { all } from 'typed-redux-saga'
import { projectSaga } from 'src/pages/knowledge/project'
import { articleSaga } from 'Pages/knowledge/articles'
import { accessSaga } from 'Pages/knowledge/access'

export function* knowledgeSaga() {
	yield* all([projectSaga(), articleSaga(), accessSaga()])
}
